import { useAppDispatch } from 'app/hooks'
import { Category } from 'enums'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'
import { getMeasureByViewOptionAndCountType } from 'utils/measureUtil'
import { CountTypeStrings } from 'enums/CountType'
import { WidgetId } from 'features/types'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { AuthorsWidgetsType } from '../../types'

const MAX_AUTHORS = 100

const createSearch = (
  widgetSetting: AuthorsWidgetsType,
  dashboardData: Dashboard,
  countType: CountTypeStrings
) => {
  const { selectedTopic, precision, viewOption } = widgetSetting
  const filter = toFilter(widgetSetting)
  const topicIds = [selectedTopic.topicId!]
  const { id: dashboardId, name } = dashboardData
  const measure = getMeasureByViewOptionAndCountType(viewOption!, countType!)
  const insightCountOptions = {
    sizeNeeded: MAX_AUTHORS
  }

  return createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    filter,
    measure!,
    [Category.AUTHORS],
    insightCountOptions
  )
}

const RunSearchEffect = ({
  widgetId,
  children,
  countType
}: {
  widgetId: WidgetId
  children: React.ReactElement
  countType: CountTypeStrings
}) => {
  const widgetSetting = useDashboardWidgetSetting<AuthorsWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!, countType)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, countType, refreshTimestamp])

  return children
}

export default RunSearchEffect
